import { Text } from '@/core/tamagoshi/Text/Text';
import { useNbProducts } from '@/productDiscovery/Listings/hooks/useNbProducts';

import { getLabel } from './translations';

export type NbProductsProps = {
  dataTestId?: string;
  revamp?: boolean;
};

export const NbProducts = ({ dataTestId, revamp = false }: NbProductsProps) => {
  const count = useNbProducts();

  const translation = getLabel(count ?? 0, revamp);

  return (
    <Text tag="span" data-testid={dataTestId}>
      {translation}
    </Text>
  );
};

NbProducts.displayName = 'NbProducts';
